import React from 'react';
import DocumentosList from '../../components/documentos/DocumentosList';

const DocumentosPage: React.FC = () => {
  return <DocumentosList />;
};

export default DocumentosPage;
